import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";
import { DeliveryCompany } from "modules/deliveryCompanies";

import { requestGetCurrentManager } from "./getCurrentManager.request";

export const COMPANY_ME_QUERY_KEY = "company-me";

const useGetCurrentCompany = (
  options?: QueryOptions<DeliveryCompany, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: [COMPANY_ME_QUERY_KEY],
    queryFn: requestGetCurrentManager,
    ...options
  });

  return { company: data, ...rest };
};

export default useGetCurrentCompany;
